module.exports = __webpack_public_path__ + "img/pr-4.9dddd111.png";